import metrikaCollector, {collectYandexReachGoal} from 'components/metrika';

export const PHONE_TEL = '88002225856';
export const PHONE_DISPLAY = '8 800 222-58-56';
export const BANNER_COLLAPSED_KEY = 'tourist_leads_banner_collapsed';
export const MAX_LINK_URL = '/tourist_leads_max_link/';

// цели по действиям виджета
const ACTION_GOALS = {
    podbor: 'contact_housing',
    max: 'contact_max',
    call: 'contact_call',
};

export function isHotelPage() {
    return Boolean(window.pageData?.is_hotel_page);
}

export function getPageType() {
    return isHotelPage() ? 'object' : 'other';
}

export function reachGoal(goal, params) {
    if (typeof yaCounter46243086 === 'undefined') {
        return;
    }

    if (params) {
        yaCounter46243086.reachGoal(goal, params);
        collectYandexReachGoal(metrikaCollector, goal, {data: params});
        return;
    }

    yaCounter46243086.reachGoal(goal);
    collectYandexReachGoal(metrikaCollector, goal);
}

/**
 * Цель по действию виджета.
 * @param {String} action    podbor / max / call
 * @param {String} placement banner / widget
 */
export function reachContactGoal(action, placement) {
    const goal = ACTION_GOALS[action];
    if (!goal) {
        return;
    }

    reachGoal(goal, {
        placement: placement,
        page_type: getPageType(),
    });
}

export function isBannerCollapsed() {
    try {
        return sessionStorage.getItem(BANNER_COLLAPSED_KEY) === '1';
    } catch (e) {
        return false;
    }
}

export function setBannerCollapsed() {
    try {
        sessionStorage.setItem(BANNER_COLLAPSED_KEY, '1');
    } catch (e) {
        // ignore
    }
}

export function fetchMaxLink() {
    return fetch(MAX_LINK_URL, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        cache: 'no-store',
    })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => (data && data.status === 'ok' ? data.max_link : ''));
}

export function openMaxLink(maxLinkPromise) {
    maxLinkPromise.then((maxLink) => {
        if (maxLink) {
            window.open(maxLink, '_blank', 'noopener,noreferrer');
        }
    });
}

export function openPhoneCall(phoneTel = PHONE_TEL) {
    if (!phoneTel) {
        return;
    }

    window.location.href = `tel:${phoneTel}`;
}

export function getWidgetContacts() {
    return window.pageData?.tourist_leads_widget || null;
}

export function resolveMaxLinkPromise(widgetContacts) {
    if (widgetContacts?.use_hotel_contacts && widgetContacts.max_link) {
        return Promise.resolve(widgetContacts.max_link);
    }

    return fetchMaxLink();
}
